import React, { PureComponent } from 'react';
import { GigCards } from '@fiverr-private/gig_card';
import _ from 'lodash';
import WideGig from '../WideGig';
import GigImpressionable from './GigImpressionable';
import '@fiverr-private/gig_card/dist/index.css';
import './index.scss';

const MIN_SCREEN_WIDTH_TO_WIDE_GIG = 1212;

export default class Gigs extends PureComponent {
    constructor(props) {
        super(props);

        const { width } = this.getWindowDimensions(),
            smallScreen = width < MIN_SCREEN_WIDTH_TO_WIDE_GIG;

        this.state = {
            width,
            showWideGig: !smallScreen,
            allGigs: [props.wideGigData.gig, ...this.props.gigs].filter(Boolean),
            wideGigCard: props.wideGigData.gig
        };

        this.updateDimensions = this.updateDimensions.bind(this);
    }

    componentDidMount() {
        this.createImpressionable();
        window.addEventListener('resize', this.updateDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
    }

    updateDimensions() {
        const { width } = this.getWindowDimensions(),
            smallScreen = width < MIN_SCREEN_WIDTH_TO_WIDE_GIG;

        this.setState({ width, showWideGig: !smallScreen });
    }

    getWindowDimensions() {
        if (!window.document) { return ({ width: undefined }); }

        const body = document.getElementsByTagName('body')[0],
            width = window.innerWidth || document.documentElement.clientWidth || body.clientWidth,
            height = window.innerHeight|| document.documentElement.clientHeight|| body.clientHeight;

        return ({ width, height });
    }

    createImpressionable() {
        const { allGigs: gigs } = this.state;

        if (!gigs || !gigs.length) { return; }

        const {
            pageCtxId,
            currentUser
        } = this.props;

        const carouselPosition = '',
            categoryId = '',
            subCategoryId = '';

        const enrichData = {
            carouselPosition,
            pageCtxId,
            currentUser,
            categoryId,
            subCategoryId,
            carouselTitle: this.carouselTitle,
            sourcepage: 'user_page'
        };

        new GigImpressionable({
            container: document.querySelector('.gigs-wrapper'),
            data: gigs
        }, enrichData);
    }

    render() {
        /* eslint-disable no-unused-vars */
        const {
            props: {
                wideGigData,
                gigs: _realGigs,
                ...gigProps
            },
            state: {
                showWideGig,
                width,
                allGigs,
                wideGigCard
            }
        } = this;
        /* eslint-disable no-unused-vars */

        const noGigs = ((allGigs.length === 0) && (wideGigCard && wideGigCard.length === 0)),
            { username, id } = gigProps.user,
            hasWideGig = !!(showWideGig && wideGigCard);

        let gigs = allGigs;

        if (hasWideGig) {
            const _allGigs = [...allGigs];
            _.remove(_allGigs, {gig_id: wideGigCard.gig_id});
            gigs = _allGigs;
        }

        return (
            <section className="gigs-wrapper">
                <header>
                    <h2>{i18n.t('user_page_perseus.users_gigs', { username })}</h2>
                </header>

                {noGigs && <div className="no-gigs">{i18n.t('user_page_perseus.no_gigs', { username })}</div>}

                {hasWideGig && (<WideGig wideGigData={wideGigData}
                    onClose={() => this.setState({showWideGig: false})}
                    {...gigProps}/>)}

                {gigs.length > 0 && <GigCards gigs={gigs} {...gigProps}/>}
            </section>
        );
    }
}



// WEBPACK FOOTER //
// ./src/common/Gigs/index.js